import { combineReducers } from 'redux';

import habitTrackingUiReducer from './habitTrackingUiReducer';
import habitTrackingDataReducer from './habitTrackingDataReducer';

export default combineReducers({
  ui: habitTrackingUiReducer,
  data: habitTrackingDataReducer,
});
